import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html,
  body {
    height: 100%;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #333333;
    font-size: 16px;

  

  }

html {  @media screen and (max-device-width: 767px) {
      overflow: hidden!important;
    }}

  * {user-select: none;}

  input { background: white; }

  textarea {
    resize: none;
    overflow: hidden;
  }

  input, textarea {color: black; user-select: auto; }

  input:focus,
  textarea:focus,
  button:focus {
    outline: none !important;
  }

  .rotateAlert,
  .resizeAlert {
    display: none;
    position: fixed;
    z-index: 99999;
  }

  .rotateAlert {
    @media screen and (max-device-width: 767px) and (orientation: landscape) {
      display: block;
    }
    @media screen and (min-device-width: 768px)  and (max-device-height: 549px)  {
      display: block;
    }
  }

  .resizeAlert {
    @media screen and (min-device-width: 768px) and (min-device-height: 550px)  {
      display: block;
      @media screen and (min-width: 768px) and (min-height: 500px) {
        display: none;
      }
    }
  }

  .af-view .af-class-header-hidden { z-index: 999!important; }

`;
